import styled from '@emotion/styled';

import {
  animation,
  border,
  fontSize,
  fontWeight,
  lineHeight,
} from '@datacamp/waffles-tokens';

const paddingSize = buttonSize => {
  switch (buttonSize) {
    case 'sm':
      return '5px 15px';
    case 'lg':
      return '15px 31px';
    default:
      return '11px 15px';
  }
};

/* eslint-disable import/prefer-default-export */
export const Container = styled.a`
  align-items: center;
  background-color: ${props => props.bg && props.bg};
  border: 1px solid transparent;
  border-radius: ${border.radius};
  border-color: ${props => props.borderColor && props.borderColor};
  box-shadow: ${props => props.boxShadow && props.boxShadow};
  color: ${props => props.textColor && props.textColor};
  display: inline-flex;
  font-size: ${props =>
    props.size && props.size === 'lg' ? fontSize.h4 : fontSize.base};
  -webkit-font-smoothing: antialiased;
  font-weight: ${fontWeight.bold};
  justify-content: center;
  letter-spacing: inherit;
  line-height: ${props =>
    props.size && props.size === 'lg' ? 1.6 : lineHeight.base};
  margin: ${props => props.margin && props.margin};
  padding: ${props => paddingSize(props.size)}; /* +1px border */
  position: relative;
  text-align: center;
  transition: background-color ${animation.transition},
    border-color ${animation.transition}, color ${animation.transition};
  user-select: none;
  white-space: nowrap;
  width: ${props => (props.width ? props.width : 'auto')};

  &:active,
  &:focus,
  &:hover {
    background-color: ${props => props.hoverBg && props.hoverBg};
    border-color: ${props =>
      props.hoverBorderColor ? props.hoverBorderColor : `transparent`};
    color: ${props =>
      props.hoverTextColor ? props.hoverTextColor : props.textColor};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.25;
    transition: opacity ${animation.transition};

    &:active,
    &:focus,
    &:hover {
      opacity: 0.25;
    }
  }
`;
